import { ReactNode } from 'react';
import { useScrollAnimation } from '../hooks';

interface FadeInProps {
  children: ReactNode;
  delay?: number;
  className?: string;
  threshold?: number;
}

export function FadeIn({ children, delay = 0, className = '', threshold = 0.1 }: FadeInProps) {
  const { ref, isVisible } = useScrollAnimation<HTMLDivElement>(threshold);

  return (
    <div
      ref={ref}
      className={`transition-all duration-700 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'} ${className}`}
      style={{ transitionDelay: `${delay}ms` }}
    >
      {children}
    </div>
  );
}
